import { render } from '@wordpress/element';
import React from 'react';
import AddToCalendar from './components/AddToCalendar';

document.addEventListener('DOMContentLoaded', () => {
	const blockElement = document.querySelector('.fsdpe-add-to-calendar');

	if (blockElement) {
		const postId = blockElement.getAttribute('data-post-id'); // Assuming post ID is stored as a data attribute

		// Make an API request to fetch event meta data
		fetch(`/wp-json/fsdpe/v1/event-meta/${postId}`)
			.then(response => response.json())  // Parse the JSON response
			.then(data => {
				// Pass the data to your React component
				render(<AddToCalendar event={data} />, blockElement);
			})
			.catch(error => console.error('Error fetching event meta:', error));
	}
});

